import type { SingleRecordResponse } from '@stakeholderlabs/types'
import { useApiGet } from '~/composables/api/useBaseFetch'
import type { Article } from '~/types/models'

export const useHomepageApi = () => {
  const show = () => {
    return useApiGet<SingleRecordResponse<Article.Model>>('/homepage')
  }

  return { show }
}
